import { ColumnSelectionFilter } from './ColumnSelectionFilter';
import { Button } from '@mui/material';
import { ColumnPreferencesConfig } from '@common/types';
import {
  useReportFoldersTableDataGridStore,
  initialReportFolderColumns,
} from '@store';

type ReportFolderColumnKey =
  'name' | 'created_at' | 'organisation' | 'updated_at' | 'report_count';

const REPORT_FOLDERS_TABLE_COLUMN_LABELS: Record<
  ReportFolderColumnKey,
  string
> = {
  name: 'Name',
  created_at: 'Created at',
  organisation: 'Organization',
  updated_at: 'Updated at',
  report_count: 'Reports',
};

const ALL_FIELDS = initialReportFolderColumns
  .map(c => c.field)
  .filter(
    f => f !== 'favorite' && f !== 'private' && f !== 'action',
  ) as ReportFolderColumnKey[];

export const ReportFoldersTableColumnSelectionFilter = ({
  hideText,
}: {
  hideText?: boolean;
}) => {
  const hiddenColumns = useReportFoldersTableDataGridStore(
    s => s.hiddenColumns,
  );
  const setHiddenColumns = useReportFoldersTableDataGridStore(
    s => s.setHiddenColumns,
  );

  const columns: Partial<
    Record<ReportFolderColumnKey, ColumnPreferencesConfig>
  > = Object.fromEntries(
    ALL_FIELDS.map((field, index) => [
      field,
      {
        column_display: hiddenColumns.includes(field) ? 'hidden' : 'display',
        column_order: index,
        column_size: 160,
      } satisfies ColumnPreferencesConfig,
    ]),
  );

  const handleSelectionChange = (
    selection: Partial<Record<ReportFolderColumnKey, ColumnPreferencesConfig>>,
  ) => {
    setHiddenColumns(
      ALL_FIELDS.filter(field => selection[field]?.column_display === 'hidden'),
    );
  };

  const handleReset = () => {
    setHiddenColumns([]);
  };

  return (
    <ColumnSelectionFilter
      name='report_folders_table_columns'
      label='Columns'
      hideText={hideText}
      columns={columns}
      columnLabels={REPORT_FOLDERS_TABLE_COLUMN_LABELS}
      onChange={handleSelectionChange}
      footerAction={
        <Button color='primary' onClick={handleReset}>
          RESET
        </Button>
      }
    />
  );
};
